// 2-Day Full-Body Hypertrophy Template Definition
// Designed for lifters training 2x per week who want to maximize hypertrophy
// Emphasizes full-body stimulation with high-quality sets, balancing push/pull, upper/lower

export const fullBodyTemplate = {
  name: "Full Body Hypertrophy",
  description: "Full-body stimulation for 2x per week training, balancing push/pull and upper/lower",
  
  exercises: {
    fullBodyA: [
      {
        primary: 'Romanian Deadlift (Barbell or Dumbbells)',
        alternatives: ['Glute Ham Raise', 'Cable Pull-Through'],
        sets: 3,
        target: 'Hamstrings, glutes'
      },
      {
        primary: 'Chest Press Machine',
        alternatives: ['Dumbbell Bench Press', 'Smith Machine Press'],
        sets: 3,
        target: 'Chest (mid/lower), front delts, triceps'
      },
      {
        primary: 'Lat Pulldown (Neutral or Underhand Grip)',
        alternatives: ['Pull-Up', 'Assisted Pull-Up'],
        sets: 3,
        target: 'Lats, biceps'
      },
      {
        primary: 'Cable Lateral Raise',
        alternatives: ['Dumbbell Lateral Raise', 'Lateral Raise Machine'],
        sets: 3,
        target: 'Side delts'
      },
      {
        primary: 'Overhead Cable Triceps Extension',
        alternatives: ['Dumbbell Overhead Extension', 'Skull Crushers'],
        sets: 3,
        target: 'Triceps (long head)'
      },
      {
        primary: 'Cable Biceps Curl',
        alternatives: ['EZ Bar Curl', 'Preacher Curl'],
        sets: 3,
        target: 'Biceps brachii'
      },
      {
        primary: 'Standing Calf Raise',
        alternatives: ['Leg Press Calf Raise', 'Smith Calf Raise'],
        sets: 3,
        target: 'Gastrocnemius'
      },
      {
        primary: 'Ab Crunch Machine',
        alternatives: ['Cable Crunch', 'Weighted Sit-Up'],
        sets: 3,
        target: 'Rectus abdominis'
      }
    ],

    fullBodyB: [
      {
        primary: 'Hack Squat',
        alternatives: ['Leg Press', 'Goblet Squat'],
        sets: 3,
        target: 'Quads (primary), glutes, adductors'
      },
      {
        primary: 'Incline Dumbbell Press',
        alternatives: ['Incline Chest Press Machine', 'Smith Incline Press'],
        sets: 3,
        target: 'Upper chest, front delts, triceps'
      },
      {
        primary: 'Close-Grip Seated Cable Row',
        alternatives: ['Chest-Supported Row', 'Barbell Row'],
        sets: 3,
        target: 'Lats, mid-back, biceps'
      },
      {
        primary: 'Shoulder Press Machine',
        alternatives: ['Dumbbell Shoulder Press', 'Smith Machine Press'],
        sets: 3,
        target: 'Delts (primarily front and side), triceps'
      },
      {
        primary: 'Preacher Curl',
        alternatives: ['Incline Dumbbell Curl', 'Cable Curl'],
        sets: 3,
        target: 'Biceps'
      },
      {
        primary: 'Cable Triceps Pushdown',
        alternatives: ['Rope Pushdown', 'Dips (Assisted)'],
        sets: 3,
        target: 'Triceps (lateral + long head)'
      },
      {
        primary: 'Seated Calf Raise',
        alternatives: ['Standing Calf Raise', 'Smith Calf Raise'],
        sets: 3,
        target: 'Soleus'
      },
      {
        primary: 'Face Pull (Cable)',
        alternatives: ['Reverse Pec Deck', 'Band Pull-Apart'],
        sets: 3,
        target: 'Rear delts, traps, rotator cuff'
      }
    ]
  }
};